import { render, staticRenderFns } from "./IsIsolatedAttic.vue?vue&type=template&id=0fe97026&"
import script from "./IsIsolatedAttic.vue?vue&type=script&lang=ts&"
export * from "./IsIsolatedAttic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports